// Ẩn hiện màn thuộc chế độ Kế toán trên thực đơn Vận hành và ô tắt trang module.
// Màn thuộc chế độ Kế toán chỉ ẩn ở Vận hành với người VÀO ĐƯỢC chế độ Kế toán (màn AccountingWorkspace trong ACUserScreens.json:
// use_Module_GL = 1 VÀ (view_Mode_Accounting = 1 HOẶC nhóm Admin)). Kit không có phủ định whenUserScreen nên viết thành mảng OR:
//   nhánh không có gói Kế toán: điều kiện cũ + use_Module_GL != 1
//   nhánh có gói nhưng không vào được: điều kiện khi có sổ cái + use_Module_GL = 1 + view_Mode_Accounting != 1 + nhóm khác Admin
// Tệp không import gì để node --test nạp được và để thực đơn Vận hành lẫn trang module dùng chung (không import vòng).

const NOT_ONE = { type: '!=', value: 1 };
const NOT_ADMIN = { type: '!=', value: 'Admin' };

// Khoá kiểu so sánh khác AND làm đổi nghĩa khi gộp thêm khoá → không hỗ trợ.
const TYPE_KEYS = { whenSys: 'whenSysType', whenUser: 'whenUserType', whenSession: 'whenSessionType' };

// Gộp thêm điều kiện vào một khối whenSys/whenUser/whenSession sẵn có, không ghi đè khoá cũ.
// Trả null khi khoá đã có giá trị mâu thuẫn hẳn (vd use_Module_GL = 1 gặp != 1) → nhánh không bao giờ đúng, bỏ nhánh.
function mergeBlock(branch, block, extra) {
    const typeKey = TYPE_KEYS[block];
    if (branch[typeKey] && branch[typeKey] !== 'AND') throw new Error('withoutAccountingMode: không gộp được vào ' + block + ' kiểu ' + branch[typeKey]);
    const cur = branch[block] || {};
    const out = { ...cur };
    for (const [k, v] of Object.entries(extra)) {
        if (cur[k] === undefined) {
            out[k] = v;
            continue;
        }
        if (JSON.stringify(cur[k]) === JSON.stringify(v)) continue;
        const neg = v && typeof v === 'object' && v.type === '!=';
        if (neg && (cur[k] === v.value || (Array.isArray(cur[k]) && cur[k].length > 0 && cur[k].every((x) => x === v.value)))) return null; // = x và != x
        if (!neg && cur[k] && typeof cur[k] === 'object' && cur[k].type === '!=' && cur[k].value === v) return null;
        throw new Error('withoutAccountingMode: ' + block + '.' + k + ' đã có điều kiện khác');
    }
    return out;
}

function addBlocks(branch, blocks) {
    const out = { ...branch };
    for (const [block, extra] of Object.entries(blocks)) {
        const merged = mergeBlock(branch, block, extra);
        if (!merged) return null;
        out[block] = merged;
    }
    return out;
}

const toBranches = (v) => (Array.isArray(v) ? v : [v || {}]);

// visible: điều kiện Vận hành khi không có gói Kế toán (object hoặc mảng OR).
// withLedger: điều kiện khi có sổ cái mà người dùng không vào được chế độ Kế toán; mặc định = visible. Dùng khi mục Vận hành có luật
// nghiệp vụ riêng cho doanh nghiệp chưa có gói (vd nhóm Thuế theo phương pháp tính thuế) còn chế độ Kế toán dùng điều kiện gọn hơn.
export function withoutAccountingMode(visible, withLedger = visible) {
    const noLedger = toBranches(visible).map((b) => addBlocks(b, { whenSys: { use_Module_GL: NOT_ONE } }));
    const noAccess = toBranches(withLedger).map((b) =>
        addBlocks(b, {
            whenSys: { use_Module_GL: 1 },
            whenUser: { view_Mode_Accounting: NOT_ONE },
            whenSession: { user_group_code: NOT_ADMIN }
        })
    );
    return [...noLedger, ...noAccess].filter(Boolean);
}

export default withoutAccountingMode;
